module.exports = __webpack_public_path__ + "static/img/logo04.2d054f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo04.png
// module id = AS2D
// module chunks = 1